import {getArgs} from './args.js';
import {lazy} from './lazy.js';

export const cond = (condition, thenAction, elseAction) => {
    return (...args) => {
        
        let _condition = lazy(condition, ...args);
        if (_condition) {
            return lazy(thenAction, ...args);
        } else {
            if (elseAction === undefined) {
                return args[0];
            }
            return lazy(elseAction, ...args);
        }
    };
};

// a <= b;
export const lte = (a,b) => {
    return (...args) => {
        let _a = lazy(a, ...args);
        let _b = lazy(b, ...args);
        return _a <= b;
    };
};

// a >= b;
export const gte = (a,b) => {
    return (...args) => {
        let _a = lazy(a, ...args);
        let _b = lazy(b, ...args);
        return _a >= b;
    };
};

// a == b;
export const eq = (a,b) => {
    return (...args) => {
        let _a = lazy(a, ...args);
        let _b = lazy(b, ...args);
        return _a === b;
    };
};

// a == b;
export const neq = (a,b) => {
    return (...args) => {
        let _a = lazy(a, ...args);
        let _b = lazy(b, ...args);
        return _a !== b;
    };
};

// a && b;
export const and = (a,b) => {
    return (...args) => {
        let _a = lazy(a, ...args);
        let _b = lazy(b, ...args);
        return _a && b;
    };
};

// a && b;
export const or = (a,b) => {
    return (...args) => {
        let _a = lazy(a, ...args);
        let _b = lazy(b, ...args);
        return _a || b;
    };
};



